import {useTranslation} from 'react-i18next';
import {CameraOff, Settings, ShieldCheck} from 'lucide-react';
import {InstructionList} from '@chekinapp/ui';

export function CameraDeniedPanel() {
  const {t} = useTranslation('identity-verification');

  return (
    <>
      <span className="grid size-[92px] place-items-center rounded-[24px] bg-[var(--chekin-blue-tint-info)] sm:size-[132px] sm:rounded-[28px]">
        <CameraOff className="size-9 text-[var(--chekin-color-brand-blue)] sm:size-12" />
      </span>

      <InstructionList
        numbered
        plain
        title={t('how_to_enable')}
        icon={<Settings />}
        className="w-full max-w-[var(--capture-max-width,480px)] [--form-section-header-bg:var(--chekin-neutral-100)]"
        items={[
          {title: t('enable_camera_step_1')},
          {title: t('enable_camera_step_2')},
          {title: t('enable_camera_step_3')},
        ]}
      />

      <p className="m-0 flex w-full max-w-[var(--capture-max-width,480px)] items-start gap-2.5 rounded-[12px] bg-[var(--chekin-color-surface-pressed)] px-3.5 py-3 text-[12px] leading-4 text-[var(--chekin-color-gray-1)]">
        <ShieldCheck className="mt-px size-4 flex-none text-[var(--chekin-color-brand-blue)]" />
        {t('camera_used_only_while_scanning')}
      </p>
    </>
  );
}
